import useDB from "../../../hooks/useDB";
import { useNavigate, useParams } from "react-router-dom";
import Error from "../../../components/Error";
import Loading from "../../../Loading";
import Text from "../../../components/Text";
import Lang from "../../../components/Lang";
import ResourceList from "../../../components/ResourceList";
import { Button, Chip } from "@mui/material";
import Info from "../../../components/Info";
import ProgressHT from "../../../components/ProgressHT";
import TextArray from "../../../components/TextArray";
import { net } from "../../../../../database";
import { useState } from "react";
import DeleteButton from "../../../components/DeleteButton";
import Staff from "../../../components/Staff";
import IconButtonHT from "../../../components/IconButtonHT";
import ResolvedIssueDialog from "../ResolvedIssueDialog";
import { LessonType } from './types';


export default function Lesson() {
    const {lessonId} = useParams()
  const [lesson, setLesson, error, loading]:[LessonType,void,boolean,boolean] = useDB(`/get-lesson/${lessonId}`)
  const [gettingIdeas, setGettingIdeas] = useState(false)
  const navigate= useNavigate()
    if(loading) return <Loading />
    if(error) return <Error />

    return (
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 10,
            paddingTop: 10,
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: 20,
            }}
          >
            <Text
              value={lesson.name}
              setValue={(name) => setLesson({ ...lesson, name })}
              url={`/update-lesson/${lesson._id}`}
              field="name"
              label={<Lang w="name" />}
              size="small"
              style={{ flexGrow: 1 }}
            />
            <Text
              value={lesson.bookPages}
              setValue={(bookPages) => setLesson({ ...lesson, bookPages })}
              url={`/update-lesson/${lesson._id}`}
              field="bookPages"
              label={<Lang w="pages" />}
              size="small"
            />
            <Text
              value={lesson.lessonNumber}
              setValue={(lessonNumber) =>
                setLesson({ ...lesson, lessonNumber })
              }
              url={`/update-lesson/${lesson._id}`}
              field="lessonNumber"
              label={<Lang w="number" />}
              size="small"
              type="number"
            />
            <Info
              title={`Percent completed ${
                parseInt(lesson.percentComplete) || 0
              }%`}
              body={<ProgressHT value={lesson.percentComplete} />}
            />
            <DeleteButton route={`/delete-lesson/${lesson._id}/${lesson.unit._id}`} success={()=>navigate(`/teaching/syllabus/${lesson.syllabus._id}/unit/${lesson.unit._id}`)} />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: 10,
            }}
          >
            <Text
              value={lesson.description}
              setValue={(description) => setLesson({ ...lesson, description })}
              url={`/update-lesson/${lesson._id}`}
              field="description"
              label={<Lang w="description" />}
              multiline
              rows={5}
              size="small"
              fontSize={12}
              style={{ flexGrow: 1 }}
            />

            <TextArray
              value={lesson.vocabulary}
              setValue={(vocabulary) => setLesson({ ...lesson, vocabulary })}
              url={`/update-lesson/${lesson._id}`}
              field="vocabulary"
              label={
                <div>
                  <Lang w="vocabulary" /> (<Lang w="oneEntryPerLine" />)
                </div>
              }
              multiline
              rows={5}
              size="small"
              fontSize={12}
              style={{ flexGrow: 1 }}
            />
            <TextArray
              value={lesson.grammar}
              setValue={(grammar) => setLesson({ ...lesson, grammar })}
              url={`/update-lesson/${lesson._id}`}
              field="grammar"
              label={
                <div>
                  <Lang w="grammarStructures" /> (<Lang w="oneEntryPerLine" />)
                </div>
              }
              multiline
              rows={5}
              size="small"
              fontSize={12}
              style={{ flexGrow: 1 }}
            />
          </div>
          <div>
            <div>Books</div>
            {lesson.syllabus.books.map((book) => (
              <Chip
                label={book.name}
                onClick={() => window.open(book.link)}
                clickable
              />
            ))}
          </div>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: 10,
              paddingTop: 10,
              paddingBottom: 10,
            }}
          >
            {resources.map((r) => (
              <ResourceList
                value={lesson}
                setValue={setLesson}
                label={r.label}
                delete
                field={r.field}
                url={`/update-lesson/${lesson._id}`}
                defaultName={`${lesson.syllabus.name} U${lesson.unit.unitNumber} L${lesson.lessonNumber}`}
                {...(r.extra && r.extra.generated && {
                generated: true 
                })}
                required={r.required}
              />
            ))}
          </div>
          <Text
            value={lesson.homework}
            setValue={(homework) => setLesson({ ...lesson, homework })}
            url={`/update-lesson/${lesson._id}`}
            field="homework"
            label={<Lang w="homework" />}
            multiline
            rows={2}
            fontSize={12}
          />
          <ResourceList
            value={lesson}
            setValue={setLesson}
            label={<Lang w="linksToHomework" />}
            type="qr"
            field="homeworkLinks"
            url={`/update-lesson/${lesson._id}`}
            defaultName={`${lesson.syllabus.name} U${lesson.unit.unitNumber} L${lesson.lessonNumber}`}
          />
          <Text
            value={lesson.folderLink}
            setValue={(folderLink) => setLesson({ ...lesson, folderLink })}
            url={`/update-lesson/${lesson._id}`}
            field="folderLink"
            label={<Lang w="linkToFolder" />}
          />
          <Issues issues={lesson.issuesDetail} lesson={lesson} setLesson={setLesson} />
          <div style={{ display: "flex" }}>
            <Text
              value={lesson.ideas}
              setValue={(ideas) => setLesson({ ...lesson, ideas })}
              url={`/update-lesson/${lesson._id}`}
              field="ideas"
              label={<Lang w="ideas" />}
              style={{ flexGrow: 1, fontSize: 12 }}
              multiline
              rows={30}
            />
            <Button
              disabled={gettingIdeas}
              onClick={async () => {
                setGettingIdeas(true);
                await net
                  .get(`/lesson-generate-ideas-ai/${lesson._id}`)
                  .then((res) => {
                    console.log(res);
                    setLesson({ ...lesson, ideas: res.ideas });
                    setGettingIdeas(false);
                  });
              }}
            >
              {gettingIdeas ? "Getting ideas" : "Get ideas"}
            </Button>
          </div>
        </div>
      </div>
    );
}

const resources = [
  { label: "Powerpoints", field: "ppts", required: true },
  { label: "Videos", field: "videos", required: true },
  { label: "Example lesson plan", field: "modelLessonPlan" },
  {
    label: "Other lesson plans",
    field: "otherLessonPlans",
    extra: { generated: true },
  },
  { label: "Teaching resources", field: "resources", required: true },
];

function Issues({ issues, lesson, setLesson }) {
  return (
    <div className="w-full">
      <div className="text-xs text-cyan-700">Issues</div>
      <div className="flex justify-between w-full">
        <div>
          {!issues || issues.length === 0
            ? "No issues"
            : issues.filter(i=>!i.resolutionDate).map((issue) => <DrawIssues issue={issue} key={issue.createdAt} lesson={lesson} setLesson={setLesson} />)}
        </div>
       
      </div>
     
    </div>
  );
}


function DrawIssues({ issue, lesson, setLesson }) {
  const dt = new Date(issue.createdAt)
  const [open,setOpen] = useState(false)
    return (
      <div className="flex justify-between w-full">
        <div style={{flexGrow:1}}>
          <div className="text-xs">
            Reported by <Staff id={issue.createdBy} /> at {dt.fTime()} on{" "}
            {dt.fDate()}
          </div>

          <div className="text-sm">{issue.description}</div>
        </div>
        <div style={{alignItems:"center"}} className="w-30">
          <IconButtonHT
            icon="tick"
            className="text-green-500"
            action={() => setOpen(true)}
          />{" "}
          Resolved
          <ResolvedIssueDialog
            open={open}
            setOpen={setOpen}
            issue={issue}
            lesson={lesson}
            setLesson={setLesson}
          />
        </div>
      </div>
    );
}